<template>
  <!-- 供应商分类工程类 -->
  <div class="ccui-app-container">
    <div class="ceontet-border">
      <div class="grayBar">供应商分类模式</div>
      <div class="pad20">
        <div class="tab-text">一旦确定了供应商分类模式，将不可更改</div>
        <el-form ref="form" :model="form">
          <el-form-item label="设置：">
            <el-radio-group
              v-model="form.mode"
              :disabled="isDisabled"
              v-if="isShow"
            >
              <el-radio label="2">使用组织分类(默认使用组织分类)</el-radio>
              <el-radio label="1">使用单位自定义分类</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="btn-box">
          <el-button
            ref="myBtn"
            :class="{ isSure: hasClass }"
            type="primary"
            @click="sureHandle()"
            :disabled="isDisabled"
          >
            确定
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryBaseData, setBaseData } from "../api/appSet";
export default {
  name: "appSet-appSetClass-supplierClassMode",
  data() {
    return {
      form: {
        mode: "2"
      },
      id: "",
      isDisabled: false, //选择了自定义，则不能再选择组织了，将按钮置为不可用。
      isShow: false,
      hasClass: false
    };
  },
  created() {
    this.queryBaseData();
  },
  methods: {
    //查询当前供应商分类状态
    queryBaseData() {
      const obj = { supplierType: "1" };
      queryBaseData(obj).then(res => {
        this.$nextTick(() => {
          this.form.mode = res.data.data.supplierClass + "";
          this.id = res.data.data.id;
          //(this.form.mode);
          this.isDisabled = this.form.mode == "1";
          this.isShow = true;
        });
      });
    },
    sureHandle() {
      if (this.isDisabled) {
        console.log("火狐会起作用吗");
        return;
      }
      console.log(this.form.mode);
      if (this.form.mode === "1") {
        this.$confirm(
          "一旦使用单位自定义分类，将不可再使用组织分类，是否继续？",
          "确认",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "ccui-message-box-custom"
          }
        )
          .then(() => {
            let obj = {
              supplierType: "1",
              supplierClass: this.form.mode,
              id: this.id
            }; //supplierType:1 供应商分类 2供应商等级,supplierClass:1单位 2组织 3平台
            setBaseData(obj).then(res => {
              this.$nextTick(() => {
                this.isDisabled = true;
                this.hasClass = true;
              });
            });
          })
          .catch(() => {
            console.log("取消继续");
          });
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "~@/config/styles/variables";
.ceontet-border {
  border: 1px solid $--color-assist-background;
}
.grayBar {
  background: $--color-assist-background;
  line-height: 36px;
  color: $--color-text-primary;
  font-size: 14px;
  padding-left: 20px;
  font-weight: 600;
}
.pad20 {
  padding-left: 20px;
}
.tab-text {
  margin: 28px 0 8px 0;
  font-size: 13px;
  color: $--color-text-primary;
}
.el-radio {
  display: flex;
  margin-top: 10px;
  margin-bottom: 15px;
}
.el-button--primary {
  width: 86px;
  height: 30px;
  border-radius: 0;
}
.btn-box {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.isSure {
  background: #ccc !important;
  cursor: not-allowed !important;
}
</style>
